module.exports = new __parcel__URL__("scatteredattacks.52e0e460.png").toString();